import { Injectable, OnDestroy, SimpleChanges, inject } from '@angular/core';
import { AnalyticsService } from '@com-delta-idp/mnx-utils';
import { Subscription } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { switchMap, tap } from 'rxjs/operators';
import { LoginHelperUtils } from '../../utils/login-helper.utils';
import { ANALYTICS_EVENTS_LOGIN } from '../constants/analytics-constants';
import { LoginDasboardService } from './login-dasboard.service';
@Injectable({
  providedIn: 'root'
})
export class LoginModalService implements OnDestroy {
  loginDashBoardService = inject(LoginDasboardService);
  loginUtilHelper = inject(LoginHelperUtils);
  analytics = inject(AnalyticsService);
  isCenterLogin$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  private _subscription: Subscription = new Subscription();

  checkOutWarmState$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  skyMilesNumber = '';
  lastEnteredUserId = '';

  redirectUrl = '';

  enableCheckOutWarmState(
    fromApp: string | undefined,
    warmState$: BehaviorSubject<boolean>,
    changes: SimpleChanges
  ) {
    this._subscription = this.loginDashBoardService
      .getLoginResponse()
      .pipe(
        tap((loginResponse) => {
          this.skyMilesNumber = loginResponse.smNumber;
        }),
        switchMap(() => {
          return this.checkOutWarmState$.pipe(
            tap((value) => {
              if (
                (fromApp === 'checkout' && value) ||
                this.loginUtilHelper.isWarmState(changes)
              ) {
                warmState$.next(true);
                this.analytics.dispatchCustomEvent(
                  ANALYTICS_EVENTS_LOGIN.WARM_STATE_LOGIN_CHECKOUT,
                  true
                );
              }
            })
          );
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
